export default __webpack_public_path__ + "static/media/thumbpics3.f23ef272.jpg";